/**
 * Created by vladislav on 19.05.20.
 */

const HomeTool = {
    reset: function () {
        cleverapps.user.currentPhysicalLevel.level = 0;
        cleverapps.user.currentPhysicalLevel.episode = 0;
        cleverapps.meta.resetProgress();
        cleverapps.meta.save();
    }
};